import _extends from "@babel/runtime/helpers/esm/extends";
import formatErrorMessage from './formatErrorMessage';
/**
 * Create a data validator
 * @param data
 */

export function createValidator(data, name) {
  return function (value, rules) {
    for (var i = 0; i < rules.length; i += 1) {
      var _rules$i = rules[i],
          onValid = _rules$i.onValid,
          errorMessage = _rules$i.errorMessage,
          params = _rules$i.params;
      var checkResult = onValid(value, data, name);

      if (checkResult === false) {
        return {
          hasError: true,
          errorMessage: formatErrorMessage(errorMessage, _extends({}, params, {
            name: Array.isArray(name) ? name.join('.') : name
          }))
        };
      } else if (typeof checkResult === 'object' && (checkResult.hasError || checkResult.array)) {
        return checkResult;
      }
    }

    return null;
  };
}
export default createValidator;